import axios from 'axios';
import { setCookie, getCookie } from '../utils';

let baseURL;
switch(process.env.REACT_APP_ENV) {
  case 'dev':
    baseURL = 'http://localhost:3001';
    break;
  case 'staging':
    baseURL = 'http://3.92.0.92/';
    break;
  default:
    baseURL = 'http://3.92.0.92/';
}

let instance;
instance = axios.create({
  baseURL: baseURL,
  transformResponse: [(res, headers) => {
    if (res === "") {
      return res;
    }
    // TODO: Add some error handling for res.headers.authorization
    const jwtToken = getCookie("jwtToken");
    if (
      (headers && headers.authorization) &&
      (!jwtToken || jwtToken.length === 0)
      // TODO: we may need to improve the setCookie implementation
      // If a key already exists, setCookie is setting duplicates
    ) {
      const jwtToken = headers.authorization.split(' ')[1];
      setCookie('jwtToken', jwtToken);

      // TODO: This is going to be handled on the backend
      // So we may not need to set it.
      // const d = new Date();
      // d.setTime(d.getTime() + (24*60*60*1000));
      // setCookie('jwtExpires', d.getTime());
    }
    return JSON.parse(res);
  }],
});

instance.interceptors.response.use(
  res => res,
  err => {
    if (err.response && err.response.status === 401) {
      setCookie("jwtToken", "");
    }
    return err;
  }
);

instance.interceptors.request.use((req) => {
  const jwtToken = getCookie('jwtToken');
  if (jwtToken.length > 0) {
    req.headers = {
      ...req.headers,
      'Authorization': `Bearer ${jwtToken}`
    }
  }
  return req;
})

// TODO: Create prod instances
export default instance;
